export const INVALID_FIRSTNAME_MESSAGE = "Le prénom est obligatoire";

export const INVALID_LASTNAME_MESSAGE = "Le nom de famille est obligatoire";

export const INVALID_EMAIL_MESSAGE = "Votre adresse email est obligatoire";
export const INVALID_EMAIL2_MESSAGE = "Votre adresse email est invalide";

export const INVALID_PHONE_MESSAGE = "Le numéro de téléphone est obligatoire";
export const INVALID_PHONE2_MESSAGE = "Le numéro de téléphone est invalide";

export const INVALID_PASSWORD_MESSAGE = "Le mot de passe est obligatoire";
export const INVALID_PASSWORD2_MESSAGE =
  "Le mot de passe doit contenir au moins 8 caractères, dont une majuscule, une minuscule, un chiffre et un caractère spécial.";

export const INVALID_BIRTHDATE_MESSAGE =
  "Votre date de naissance est obligatoire";

export const INVALID_MINIMUM_CARACTERE_MESSAGE =
  "Ce champ doit avoir au minimum 2 caractères";

export const INVALID_MAXIMUM_CARACTERE_MESSAGE =
  "Ce champ doit avoir au maximum 255 caractères";

export const INVALID_NAME_MESSAGE = "Le nom est obligatoire";

export const INVALID_FORM_MESSAGE =
  "Veuillez vérifier les champs du formulaire";
